import injector from 'vue-inject'

/**
 * Service used for exploitation data
 */
class TechnicalService {
  constructor(axios, apiRoot) {
    this.axios = axios
    this.apiRoot = apiRoot
  }

  /**
   * Return battery levels of sessions from a specific site and time
   * @param {*} site
   * @param {*} date
   */
  async getBatteryLevelsForSiteAndDate(site, date) {
    const url = `${this.apiRoot}/battery/level?site_location=${site}&date=${date}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Get battery temperatures of sessions (temperature or levels) from a specific site ID and time
   * @param {*} site
   * @param {*} date
   */
  async getBatteryTemperaturesForSiteAndDate(site, date) {
    const url = `${this.apiRoot}/battery/temperature?site_location=${site}&date=${date}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Get battery informations from sessions (temperature or levels) according to a site ID and time
   * @param {*} site
   * @param {*} date
   */
  async getBatteryInformationsForSiteAndDate(site, dataValue, date) {
    const url = `${this.apiRoot}/battery/informations?site_location=${site}&dataValue=${dataValue}&date=${date}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Get battery informations of sessions (temperature or levels) from a specific device serial
   * @param {*} deviceSerial
   * @param {*} start
   * @param {*} end
   */
  async getBatteryInformationsForDeviceAndDate(deviceSerial, dataValue, start, end) {
    const url = `${this.apiRoot}/battery/level/device?device_serial=${deviceSerial}&dataValue=${dataValue}&startDate=${start}&endDate=${end}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Get battery informations from sessions (temperature or levels) according to a site ID and time
   * @param {*} site
   * @param {*} date
   */
  async getBatteryGradientsForSiteAndPeriod(site, dataValue, dataType, start, end) {
    const url = `${this.apiRoot}/battery/gradients?site_location=${site}&data_value=${dataValue}&data_type=${dataType}&startDate=${start}&endDate=${end}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Get battery informations from sessions (temperature or levels) according to a site ID and time
   * @param {*} site
   * @param {*} date
   */
  async getBatteryGradientsDistributionForSiteAndPeriod(site, dataValue, dataType, start, end) {
    const url = `${this.apiRoot}/battery/gradients/distribution?site_location=${site}&data_value=${dataValue}&data_type=${dataType}&startDate=${start}&endDate=${end}`
    return this.axios.get(url).then(response => response.data)
  }
}

injector.service('technicalService', ['axios', 'apiRoot'], TechnicalService)
